import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import styles from './subcategoryListExp.module.scss'

enum SUBCATEGORY_LIST_TYPE {
  image = 'image',
  text = 'text',
}

const SUB_CAT_CONFIG_MAP = {
  [SUBCATEGORY_LIST_TYPE.image]: 2,
  [SUBCATEGORY_LIST_TYPE.text]: 3,
}

const IMAGE_DATA = {
  viewNumber: SUB_CAT_CONFIG_MAP[SUBCATEGORY_LIST_TYPE.image],
  breadCrumbListClass: styles.imageBreadCrumbListClass,
}

const TEXT_DATA = {
  viewNumber: SUB_CAT_CONFIG_MAP[SUBCATEGORY_LIST_TYPE.text],
  breadCrumbListClass: undefined,
}

const useGetSubCategoryConfig = () => {
  const deviceInfo = useDeviceInfo()

  const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE
  if (isMobile) {
    return TEXT_DATA
  } else {
    return IMAGE_DATA
  }
}

export default useGetSubCategoryConfig
